import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RecurringPaymentPlanPage } from './recurring-payment-plan.page';
import { RecurringPaymentPlanPageRoutingModule } from './recurring-payment-plan-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RecurringPaymentPlanPageRoutingModule,
  ],
  declarations: [RecurringPaymentPlanPage],
})
export class RecurringPaymentPlanPageModule {}
